(function () {
  var NOTE_H = "Ordering youth and adult sizes together?";
  var NOTE_B = " Youth shirts are smaller, so the design is resized to fit them and they're treated as a separate order. Youth pieces are priced on their own quantity.";
  var KEYS = { youth: 1, kids: 1, youths: 1 };
  var LEGACY = ["S", "M", "L", "XL", "2XL", "3XL", "XS"];
  var booted = false;
  function $(id) { return document.getElementById(id); }
  function slug(s) { return String(s || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, ""); }
  function isReq() { return !!$("reqPage"); }
  function isCat() { return !!$("groups") && !!$("grid") && !isReq() && !document.querySelector("#rvaCat.rva-style-page"); }
  function st(id) { return typeof window.styleById === "function" ? window.styleById(id) : null; }
  function grp(s) { return s && s.y ? "y" : s && s.w ? "w" : "u"; }
  var GNAME = { u: "Unisex", w: "Women's", y: "Youth" };

  function withOrder(order, fn, self, args) {
    var S = window.SIZES, keep = S.slice();
    S.length = 0; Array.prototype.push.apply(S, order);
    try { return fn.apply(self, args); } finally { S.length = 0; Array.prototype.push.apply(S, keep); }
  }
  function patchSizes() {
    var S = window.SIZES;
    if (!Array.isArray(S) || S.indexOf("XS") >= 0) return;
    S.unshift("XS");
    if (window.SIZE_WORD) window.SIZE_WORD.XS = "X-Small";
    window.upOf = function (e, t) { var z = window.SIZES[t]; return (z === "2XL" ? e.up[0] : z === "3XL" ? e.up[1] : 0) || 0; };
    window.lineFootPrice = function (a, t, n) {
      var base = window.lineBase(a, t.color, n), parts = [], money = window.money;
      if (["XS", "S", "M", "L", "XL"].some(function (z) { return t.sizes[z]; })) parts.push((a.y ? a.sizes : "S–XL") + " " + money(base) + " ea");
      if (t.sizes["2XL"]) parts.push("2XL " + money(base + (a.up[0] || 0)) + " ea");
      if (t.sizes["3XL"]) parts.push("3XL " + money(base + (a.up[1] || 0)) + " ea");
      return parts.join(" · ");
    };
    ["shareURL", "loadShared"].forEach(function (name) {
      var f = window[name];
      if (typeof f !== "function" || f.rvaYth) return;
      var g = function () { return withOrder(LEGACY, f, this, arguments); };
      g.rvaYth = 1; window[name] = g;
    });

    var m = /(?:^|[#&])r=([A-Za-z0-9_-]+)/.exec(location.hash || "");
    if (m && window.S) { try { window.loadShared(m[1]); } catch (e) {} }
  }

  function pieces(g) {
    var n = 0, S = window.S;
    (S && S.req || []).forEach(function (r) { var s = st(r.id); if (s && grp(s) === g) window.SIZES.forEach(function (z) { n += r.sizes[z] || 0; }); });
    return n;
  }
  function groups() { return ["u", "w", "y"].filter(function (g) { return pieces(g) > 0; }); }
  function youthMixed() { var g = groups(); return g.length > 1 && g.indexOf("y") >= 0; }
  function anyMixed() { return groups().length > 1; }
  function tierLbl(n) { return window.tierFor(Math.max(n, window.MIN_PIECES || 12)).label; }
  function tiersText() { return groups().map(function (g) { return GNAME[g] + ": " + tierLbl(pieces(g)) + " tier"; }).join(" · "); }
  function minText() {
    var min = window.MIN_PIECES || 12;
    return groups().filter(function (g) { return pieces(g) < min; }).map(function (g) { return GNAME[g] + " order is under the " + min + "-piece minimum."; }).join(" ");
  }
  function specText() { var i = window.inkSpec(); return i.charAt(0).toUpperCase() + i.slice(1) + " · " + window.reqPieces() + " pieces · " + tiersText(); }

  function patchPricing() {
    if (window.lineBase && window.lineBase.rvaYth) return;
    window.lineBase = function (e, c, n) {
      if (e && n === window.reqPieces() && anyMixed()) n = pieces(grp(e));
      var fl = e.t === "fleece";
      return window.costOf(e, c) + (fl ? window.FLEECE_GARMENT : 0) + window.printCost(window.tierFor(Math.max(n, window.MIN_PIECES || 12)), window.S.front, window.S.back, fl);
    };
    window.lineBase.rvaYth = 1;
    wrapOut("reqSpec", function (out) { return youthMixed() ? specText() : out; });
    wrapOut("specLine", function (out) { return youthMixed() ? specText() : out; });
    wrapOut("totalsHTML", function (out) {
      return youthMixed() ? out.replace(/(<div><span>Pricing tier<\/span><span>)[^<]*(<\/span><\/div>)/, "$1" + tiersText().replace(/'/g, "&#39;") + "$2") : out;
    });
    wrapOut("submitURL", function (out) {
      if (!youthMixed()) return out;
      var q = out.indexOf("?"), p = new URLSearchParams(out.slice(q + 1)), S = window.S;
      p.set("printLocations", (S.front ? "Front " + S.front + "-color" : "") + (S.front && S.back ? ", " : "") + (S.back ? "Back " + S.back + "-color" : "") + " · " + window.reqPieces() + " pieces (" + tiersText() + ")");
      return out.slice(0, q + 1) + p.toString().split("+").join("%20");
    });
  }
  function wrapOut(name, after) {
    var f = window[name];
    if (typeof f !== "function" || f.rvaYth) return;
    var g = function () { return after(f.apply(this, arguments)); };
    g.rvaYth = 1; window[name] = g;
  }
  function hook(name, fn) {
    var f = window[name];
    if (typeof f !== "function" || f.rvaYthHook) return;
    var g = function () { var r = f.apply(this, arguments); try { fn.apply(this, arguments); } catch (e) {} return r; };
    g.rvaYthHook = 1; window[name] = g;
  }

  function css() {
    if ($("ythCss")) return;
    var e = document.createElement("style"); e.id = "ythCss";
    e.textContent = ".ythNote{margin:0 0 18px;padding:14px 18px 14px 16px;border:0;border-left:5px solid var(--red,#e5252e);border-radius:var(--r,6px);background:var(--blush,#ffe3de);color:var(--ink,#3f0d1b);font-family:var(--font,inherit);font-size:15px;font-weight:500;line-height:1.5;text-align:left;box-shadow:0 8px 22px -12px rgba(229,37,46,.5)}.ythNote strong{display:block;margin:0 0 3px;font-size:16.5px;font-weight:800;letter-spacing:-.01em;color:var(--red-2,#b8151e)}.ythNote--grid{grid-column:1/-1;max-width:820px}.ythNote--panel{margin:14px 0 0;font-size:14px}.ythNote--panel strong{font-size:15px}.ythNote--req{margin:0 0 16px}.ythNote--toast{margin:0 14px 12px;padding:9px 12px;border-left-width:4px;font-size:12.5px;box-shadow:none}.ythNote--toast strong{display:inline;font-size:inherit}.ythNote--min{margin-top:-8px;font-weight:700}@media (max-width:749px){.ythNote{font-size:14px;padding:12px 14px 12px 13px}.ythNote strong{font-size:15.5px}}";
    document.head.appendChild(e);
  }
  function note(id, cls) {
    var n = $(id);
    if (!n) { n = document.createElement("p"); n.id = id; n.className = "ythNote " + (cls || ""); n.setAttribute("role", "note"); n.innerHTML = "<strong>" + NOTE_H + "</strong>" + NOTE_B; }
    return n;
  }
  function put(el, parent, before) { if (parent && (el.parentNode !== parent || el.nextSibling !== (before || null))) parent.insertBefore(el, before || null); }
  function drop(id) { var e = $(id); if (e && e.parentNode) e.parentNode.removeChild(e); }
  function minNote(id, cls, parent, after) {
    var t = youthMixed() ? minText() : "";
    if (!t || !parent) { drop(id); return; }
    var n = $(id);
    if (!n) { n = document.createElement("p"); n.id = id; n.className = "ythNote ythNote--min " + (cls || ""); n.setAttribute("role", "note"); }
    if (n.textContent !== t) n.textContent = t;
    put(n, parent, after ? after.nextSibling : parent.firstChild);
  }
  function reqNotes() {
    var mixed = youthMixed();
    if (mixed) ["wmReqMin", "wmDrawMin", "wmToastMin"].forEach(drop);
    [["rLines", "ythReqNote", "ythReqMin"], ["dBody", "ythDrawNote", "ythDrawMin"]].forEach(function (x) {
      var box = $(x[0]); if (!box) return;
      if (mixed && box.firstChild) put(note(x[1], "ythNote--req"), box, box.firstChild); else drop(x[1]);
      minNote(x[2], "ythNote--req", box, $(x[1]));
    });
    var d = $("dSpec"); if (d && mixed && window.S.req.length) d.textContent = specText();
    var r = $("rSay"); if (r && mixed) r.textContent = specText();
  }
  function toastNote() {
    var card = document.querySelector("#rvaToast .rtCard"), acts = card && card.querySelector(".rtActs");
    if (!acts) return;
    if (youthMixed()) { put(note("ythToastNote", "ythNote--toast"), card, acts); ["wmToastMin"].forEach(drop); }
    else drop("ythToastNote");
    minNote("ythToastMin", "ythNote--toast", card, $("ythToastNote"));
  }
  function reorderXS() {

    Array.prototype.forEach.call(document.querySelectorAll('#panel .sizeGrid, #dBody .lineQty'), function (box) {
      var xs = box.querySelector('input[data-z="XS"], input[data-lz="XS"]');
      var cell = xs && xs.closest(".sz, .lq");
      if (cell && box.firstElementChild !== cell) box.insertBefore(cell, box.firstElementChild);
    });
  }
  function panelTweaks() {
    var S = window.S, s = S && S.open && st(S.open), p = $("panel");
    if (!p || !s) return;
    reorderXS();
    if (!s.y) { drop("ythPanelNote"); return; }
    Array.prototype.forEach.call(p.querySelectorAll(".pPriceSub, .szChart th"), function (el) {
      if (el.innerHTML.indexOf("S–XL") >= 0 && el.innerHTML.indexOf(s.sizes) < 0) el.innerHTML = el.innerHTML.replace("S–XL", s.sizes);
    });
    var box = p.querySelector(".pPriceBox"), n = note("ythPanelNote", "ythNote--panel");
    if (box && box.parentNode) put(n, box.parentNode, box.nextSibling);
    else { var add = p.querySelector(".addRow"); if (add && add.parentNode) put(n, add.parentNode, add); }
  }

  function optCount() {
    var S = window.S, keepY = S.yv, keepW = S.wv, n = 0;
    S.yv = { youth: 1 }; S.wv = {};
    try { n = window.filtered().length; } catch (e) {} finally { S.yv = keepY; S.wv = keepW; }
    return n;
  }
  function rail() {
    var S = window.S, on = !!(S.yv && S.yv.youth);
    var anchor = $("wmOpt") || document.querySelector('#groups .opt[data-g="type"]');
    if (anchor && !$("ythOpt")) {
      var d = document.createElement("div");
      d.innerHTML = typeof window.optHTML === "function" ? window.optHTML("yv", "youth", "Youth", 0) : '<button class="opt" type="button" data-g="yv" data-k="youth" aria-pressed="false"><span class="box"></span><span>Youth</span><span class="n">0</span></button>';
      var b = d.firstChild; b.id = "ythOpt";
      anchor.parentNode.insertBefore(b, anchor.nextSibling);
    }
    var o = $("ythOpt");
    if (o) { o.setAttribute("aria-pressed", String(on)); var c = o.querySelector(".n"); if (c) c.textContent = String(optCount()); }
    var chips = $("chips");
    if (chips && on && !chips.querySelector('[data-g="yv"]')) chips.insertAdjacentHTML("afterbegin", '<span class="chip">Youth<button type="button" data-g="yv" data-k="youth" aria-label="Remove Youth filter">×</button></span>');
    if (on) { var ca = $("clearAll"); if (ca) ca.hidden = false; }
    var fb = $("filtBtn");
    if (fb && typeof window.activeFilters === "function") {
      var k = window.activeFilters() + (S.wv && S.wv.womens ? 1 : 0) + (on ? 1 : 0);
      fb.textContent = k ? "Filters · " + k : "Filters";
    }
    var grid = $("grid");
    if (grid && on && isCat()) put(note("ythGridNote", "ythNote--grid"), grid.parentNode, grid); else drop("ythGridNote");
  }
  function hashSaysYouth(h) {
    var s = String(h || "").replace(/^[#?]/, ""), yes = false, other = false;
    if (!s) return null;
    s.split("&").forEach(function (part) {
      var i = part.indexOf("="), k, v;
      if (i < 0) { if (KEYS[slug(part)]) yes = true; return; }
      try { k = decodeURIComponent(part.slice(0, i)).toLowerCase(); v = decodeURIComponent(part.slice(i + 1)); } catch (e) { return; }
      if ((k === "type" || k === "view" || k === "t") && v.split(",").some(function (x) { return KEYS[slug(x)]; })) yes = true;
      else if (/^(type|brand|fab|fabric|weight|color|colour|fam|q)$/.test(k)) other = true;
    });
    return yes ? true : other ? false : null;
  }
  function applyHash(clear) {
    if (!booted || !isCat()) return false;
    var S = window.S, want = hashSaysYouth(location.hash);
    if (want === null) return false;
    var on = !!(S.yv && S.yv.youth);
    if (want && clear) {
      ["type", "brand", "fam", "weight", "fab"].forEach(function (g) { S[g] = {}; });
      S.q = ""; var q = $("q"); if (q) q.value = "";
    }
    if (want === on && !clear) return false;
    S.yv = want ? { youth: 1 } : {};
    if (want) S.wv = {};
    window.render();
    return true;
  }

  function boot() {
    if (booted) return true;
    var S = window.S;
    if (!S || typeof window.render !== "function" || typeof window.filtered !== "function" || !Array.isArray(window.SIZES) || typeof window.lineBase !== "function") return false;
    booted = true;
    css(); patchSizes(); patchPricing();
    S.yv = S.yv || {};
    var base = window.filtered;
    window.filtered = function () {
      var y = !!(S.yv && S.yv.youth), w = !!(S.wv && S.wv.womens), q = $("q");
      var searching = !!(String(S.q || "").trim() || (q && !isReq() && String(q.value || "").trim()));
      var list = base.apply(this, arguments);
      if (w) return list;
      return list.filter(function (s) { return y ? !!s.y : !s.y || searching; });
    };
    var card = window.cardHTML;
    if (typeof card === "function") window.cardHTML = function (s) {
      var h = card.apply(this, arguments);
      return s && s.y && window.TYPE_LABEL ? h.replace('<span class="tag">' + window.TYPE_LABEL[s.t] + "</span>", '<span class="tag wmTag">Youth</span>') : h;
    };
    hook("render", function () { if (isCat()) rail(); reqNotes(); reorderXS(); });
    hook("drawLines", function () { reqNotes(); var t = document.querySelectorAll('#rLines tr.rRow input[data-lz="XS"]'); Array.prototype.forEach.call(t, function (inp) { var row = inp.closest("tr"), line = inp.getAttribute("data-line"), first = $("rg" + line); if (first && first !== row) { first.parentNode.insertBefore(row, first); first.removeAttribute("id"); row.id = "rg" + line; } }); });
    hook("drawDrawer", function () { reqNotes(); reorderXS(); });
    hook("repriceDrawer", reqNotes);
    hook("repriceReq", reqNotes);
    hook("drawPanel", panelTweaks);
    window.addEventListener("rva:request", function () { setTimeout(function () { reqNotes(); toastNote(); }, 0); });
    var g = $("groups");
    if (g) g.addEventListener("click", function (e) {
      var o = e.target.closest && e.target.closest(".opt");
      if (!o) return;
      if (o.dataset.g === "yv") S.wv = {};
      else if (o.dataset.g === "wv") S.yv = {};
    }, true);
    var ca = $("clearAll");
    if (ca) ca.addEventListener("click", function () { if (S.yv && S.yv.youth) { S.yv = {}; window.render(); } });
    if (hashSaysYouth(location.hash) && isCat()) { S.yv = { youth: 1 }; S.wv = {}; }
    window.render();
    return true;
  }

  window.addEventListener("hashchange", function () { applyHash(true); });
  document.addEventListener("click", function (e) {
    var a = e.target && e.target.closest ? e.target.closest("a[href]") : null;
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || !booted || !isCat()) return;
    var href = a.getAttribute("href") || "", i = href.indexOf("#");
    if (i < 0) return;
    var path = href.slice(0, i).replace(/^https?:\/\/[^\/]+/, "");
    if (path && path !== location.pathname) return;
    if (hashSaysYouth(href.slice(i)) !== true) return;
    e.preventDefault(); e.stopImmediatePropagation();
    try { history.replaceState(null, "", location.pathname + href.slice(i)); } catch (x) {}
    applyHash(true);
    var grid = $("grid"); if (grid) try { grid.scrollIntoView({ block: "start", behavior: "smooth" }); } catch (x) {}
  }, true);
  if (!boot()) {
    var root = $("rvaCat");
    if (root && window.MutationObserver) { var mo = new MutationObserver(function () { if (boot()) mo.disconnect(); }); mo.observe(root, { childList: true, subtree: true }); }
    document.addEventListener("DOMContentLoaded", function () { if (!boot()) window.addEventListener("load", boot); });
  }
})();